import styled from 'styled-components';

export const CouponSaveWrapStyle = styled.div`
  position: relative;

  .coupon-save-info,
  .coupon-save-product-link-info,
  .coupon-save-brand-link-info {
    background-color: #fff;
    padding: 20px 5px 5px 5px;

    &:not(:last-child) {
      margin-bottom: 15px;
    }

    & > * {
      margin-bottom: 5px;

      &:not(.title) {
        padding-left: 30px;
      }
    }

    & > .title {
      font-size: 25px;
      padding: 0 0 5px 30px;
      border-bottom: 1px solid #dee2e6;
      margin-bottom: 10px;
    }
  }
`;
